(function(){
    "use strict";
    angular.module('SmartAdmin.Layout', []);
})();
